module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t3-12.ae469894.svg";